
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 7.509a3.053 3.053 0 01-1.537-.277c-6.747-3.983-7.982 2.828-7.3 7.027.764 4.67 2.744 8.609 5.474 8.973a1.351 1.351 0 00.785-.162l1.916-.975a1.441 1.441 0 011.316 0l1.916.975a1.351 1.351 0 00.785.162c2.73-.364 4.71-4.3 5.474-8.973.371-2.259.186-5.273-1.115-6.959m-1.165-2.716a5.1 5.1 0 01-2.56 1.308.924.924 0 01-1.162-1.184A5.253 5.253 0 0116.111 2.1a5.086 5.086 0 012.56-1.309.925.925 0 011.162 1.184 5.264 5.264 0 01-1.284 2.609zM12 3.759v3.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    